/** Default tip percent options sent to the pay terminal during onboarding */
export const DEFAULT_TIP_PERCENT_OPTIONS = [0.1, 0.15, 0.2] as const;

/** Tip configuration value object — whether tips are accepted at the payment terminal */
export type TipConfig = Readonly<{
  enabled: boolean;
}>;

/**
 * Creates a validated TipConfig value object.
 *
 * @param enabled - Whether tips are accepted at the payment terminal
 * @returns Frozen TipConfig
 */
export const createTipConfig = (enabled: boolean): TipConfig => {
  return Object.freeze({ enabled });
};
